// apps/landing-page/src/hooks/useNow.ts
'use client';

import { useState, useEffect } from 'react';

/** Hydration-safe wall clock: null until mounted, so the phase used for the very first
 * client render (hydration) matches the server's (both null), instead of racing Date.now()
 * against the server's render time. Ticks afterward so cards/CTAs recompute as event
 * windows, registration windows, etc. cross. Single shared instance per top-level
 * component, never one interval per card. */
export function useNow(intervalMs = 30000): number | null {
  const [now, setNow] = useState<number | null>(null);

  useEffect(() => {
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
